import { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "../../components/inputs/form";
import Textbox from "../../components/inputs/textbox";
import Submit from "../../components/inputs/submit";
import RegisterTicketApi from "../../api/register-ticket";
import AuthContext from "../../components/auth-context";
import TicketSubjectsApi from "../../api/subjects";
import useAppNavigate from "../../components/router/use-app-navigate";
import Select from "../../components/inputs/select";

interface RegisterTicketForm {
  serviceItemId: number;
  subjectId: number;
  description: string;
}

export default function RegisterTicket() {
  var { register, handleSubmit } = useForm<RegisterTicketForm>();
  var [subjects, setSubjects] = useState([]);
  const navigate = useAppNavigate();
  const selectedServiceItemId = 12;

  const context = useContext(AuthContext),
    { activeFileId } = context;

  useEffect(() => {
    if (activeFileId) {
      const ticketSubjectsApi = new TicketSubjectsApi(context);
      ticketSubjectsApi.get(selectedServiceItemId).then((data) => {
        setSubjects(data);
      });
    }
    // eslint-disable-next-line
  }, []);

  const onSubmit: (data: any) => Promise<string> = ({
    serviceItemId,
    subjectId,
    description,
  }) => {
    const registerTicketApi = new RegisterTicketApi(context);
    const { activeFileId } = context;
    return registerTicketApi
      .post({ fileId: activeFileId!, serviceItemId, subjectId, description })
      .then(({ errorMessage }) => {
        if (!errorMessage) {
          navigate("/tickets");
        }
        return errorMessage;
      });
  };

  return (
    <Form submit={onSubmit} handleSubmit={handleSubmit}>
      <Select
        {...register("serviceItemId", { required: true })}
        label="نوع خدمت"
        options={[{ name: "12", value: "پشتیبانی اینترنت" }]}
      />
      <Select
        {...register("subjectId", { required: true })}
        label="موضوعات"
        options={[
          ...subjects.map(({ title, value }) => ({
            name: value,
            value: title,
          })),
        ]}
      />
      <Textbox {...register("description")} label="توضیحات" />
      <Submit />
    </Form>
  );
}
